import { observer } from 'mobx-react-lite'
import { Share2 } from 'blaze-ui/icons'
import { AlmanacFileSummary } from 'types'
import { useIsChannelPostable } from 'components/PostStatusDropdown/utils'
import { useRootStore } from 'stores/RootStore'
import { PublishDrawer } from 'components/Design/PublishTab/PublishDrawer'
import { DesignDownloadDrawer } from 'components/DesignDownloadModal/DesignDownloadDrawer'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { Send2 } from 'blaze-ui/icons/24'

export interface Props {
  file: AlmanacFileSummary
}

const MobilePublishButton = observer(({ file }: Props) => {
  const { drawersStore } = useRootStore()
  const { isChannelSocialPostable } = useIsChannelPostable()
  const channel = file?.channel || undefined
  const scheduledPostId = file.scheduled_post_id
  const isPostable = isChannelSocialPostable(channel)

  const handleDownload = () => {
    drawersStore.openDrawer(DesignDownloadDrawer)
  }

  const handlePublish = () => {
    drawersStore.openDrawer(PublishDrawer)
  }

  return (
    <>
      {isPostable && scheduledPostId && channel ? (
        <MobileButton onPress={handlePublish} icon={Send2} aria-label="Publish">
          Publish
        </MobileButton>
      ) : (
        <MobileButton onPress={handleDownload} icon={Share2} aria-label="Export">
          Export
        </MobileButton>
      )}
    </>
  )
})

export { MobilePublishButton }
